export default {
  "freeSpinConfig.title": "Free Spin Config",
  "freeSpinConfig.column.no": "#NO",
  "freeSpinConfig.column.freeSpinBonusId": "FreeSpinBonusId",
  "freeSpinConfig.column.gameId": "GameId",
  "freeSpinConfig.column.betAmount": "BetAmount",
  "freeSpinConfig.column.rounds": "Rounds",
  "freeSpinConfig.column.jumpUrl": "JumpUrl",
  "freeSpinConfig.column.chanceType": "ChanceType",
  "freeSpinConfig.column.startTime": "StartTime",
  "freeSpinConfig.column.endTime": "EndTime",
  "freeSpinConfig.column.action": "Action",
  "freeSpinConfig.action.delete": "Delete",
  "freeSpinConfig.action.add": "Add",
  "freeSpinConfig.action.edit": "Edit",
  "freeSpinConfig.form.gameId": "GameId",
  "freeSpinConfig.form.betAmount": "BetAmount",
  "freeSpinConfig.form.rounds": "Rounds",
  "freeSpinConfig.form.withdrawLimit": "WithdrawLimit",
  "freeSpinConfig.form.startTime": "StartTime",
  "freeSpinConfig.form.endTime": "EndTime",
  "freeSpinConfig.form.jumpUrl": "JumpUrl",
  "freeSpinConfig.form.chanceType": "ChanceType",
  "freeSpinConfig.confirm.delete.title": "Delete Free Spin: {freeSpinBonusId}",
  "freeSpinConfig.confirm.delete.content": "Are you sure you want to delete this free spin?",
  "freeSpinConfig.confirm.ok": "Confirm",
  "freeSpinConfig.confirm.cancel": "Cancel",
  "freeSpinConfig.add": "Add",
  "freeSpinConfig.edit": "Edit",
};